"use client";
import React, { useState, useEffect, useRef } from 'react';

const LazyLoad = ({ children, rootMargin = '200px', minHeight = '300px' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.unobserve(domRef.current);
        }
      },
      {
        rootMargin,
      }
    );
    
    if (domRef.current) {
      observer.observe(domRef.current);
    }
    
    return () => {
      if (domRef.current) {
        observer.unobserve(domRef.current);
      }
    };
  }, [rootMargin]);

  return (
    <div ref={domRef} style={{ minHeight, width: '100%' }}>
      {isVisible ? children : null}
    </div>
  );
};

export default LazyLoad;
